import { useQuery } from '@tanstack/react-query';
import type { BehaviouralFlagKind } from 'shared';

import { listFlags } from '../../lib/api/endpoints';

export const flagKeys = {
  all: ['flags'] as const,
  list: (filters: { from?: string; kind?: BehaviouralFlagKind; unack?: boolean }) =>
    [...flagKeys.all, filters] as const,
  active: () => [...flagKeys.all, 'active'] as const,
};

export function useFlags(filters: { from?: string; kind?: BehaviouralFlagKind; unack?: boolean }) {
  return useQuery({
    queryKey: flagKeys.list(filters),
    queryFn: () => listFlags(filters),
  });
}

export function useActiveFlags() {
  return useQuery({
    queryKey: flagKeys.active(),
    queryFn: () => listFlags({ unack: true }),
  });
}
